import { render, staticRenderFns } from "./InvoiceBody.vue?vue&type=template&id=40ac0b56&"
import script from "./InvoiceBody.vue?vue&type=script&lang=js&"
export * from "./InvoiceBody.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ac0b56')) {
      api.createRecord('40ac0b56', component.options)
    } else {
      api.reload('40ac0b56', component.options)
    }
    module.hot.accept("./InvoiceBody.vue?vue&type=template&id=40ac0b56&", function () {
      api.rerender('40ac0b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Billing/BillingInvoice/InvoiceBody.vue"
export default component.exports